import React from 'react';
import './DashboardTaskbarBody.css';
import DashboardTaskbarBodyTab from "../DashboardBodyTabs/DashboardTaskbarBodytTabs";
import descriptionDetails from './DashboardDescription';

const DasboardTaskbarBlogsBody = () => {
    return (
        <div className="dashboardtaskbarbody">
            <DashboardTaskbarBodyTab header="Blog Ideas" link="/generate/BlogIdeas"  body={descriptionDetails.Blog_Ideas} />
            <DashboardTaskbarBodyTab header="Blog Intro" link="/generate/BlogIntro" body={descriptionDetails.Blog_Intro} />
            <DashboardTaskbarBodyTab header="Blog Outline" link="/generate/BlogOutline" body={descriptionDetails.Blog_Outline} />
            {/* <DashboardTaskbarBodyTab header="Blog Post" body={descriptionDetails.Blog_Post} /> */}
            <DashboardTaskbarBodyTab header="Blog Quote" link="/generate/BlogQuote"  body={descriptionDetails.Blog_Quote} />

        </div>
    )
}

export default DasboardTaskbarBlogsBody;
